import React, {useEffect, useRef, useState} from "react"
import Button from "../Button"
import {IconContext} from "react-icons/lib"
import {HiChevronDown, HiChevronUp} from "react-icons/hi"
import {FaCheck} from "react-icons/fa6"
import {FiSearch} from "react-icons/fi"

type OptionType = {
	value: string
	label: string
}

interface DropdownSearchProps {
	options: OptionType[]
	label: string
	id: string
	selectedVal?: string
	handleChange: (val: string) => void
}

const DropdownSearch = ({options, label, id, selectedVal, handleChange}: DropdownSearchProps) => {
	const [query, setQuery] = useState("")
	const [isOpen, setIsOpen] = useState(false)
	const [isCollapsed, setIsCollapsed] = useState(false)

	const inputRef = useRef(null)
	const collapseRef = useRef(null)

	useEffect(() => {
		document.addEventListener("click", handleClickOutside)
		return () => document.removeEventListener("click", handleClickOutside)
	}, [])

	const selectOption = (option: OptionType) => {
		setQuery(() => "")
		handleChange(option.value)
		setIsOpen(false)
	}

	const handleClickInside = () => {
		setIsOpen(true)
	}

	function handleClickOutside(e: MouseEvent) {
		e.preventDefault()
		if ((e.target as HTMLElement).classList.contains("collapse-btn")) {
			return
		} else if (collapseRef?.current?.contains(e.target)) {
			return
		} else if ((e.target as HTMLInputElement).name === "searchTerm") {
			return
		} else if (!inputRef?.current.contains(e.target as HTMLInputElement)) {
			setIsOpen(false)
		}
	}

	const getDisplayValue = () => {
		if (query) return query
		//if (selectedVal) return options.find(_ => _.value === selectedVal).label

		return ""
	}

	const filter = (opt: OptionType[]) => {
		return [...opt].filter(option => option[label].toLowerCase().indexOf(query.toLowerCase()) > -1)
	}

	const selectedClass = (cls: string, value: string): string => {
		if (value === selectedVal) return `${cls} ${cls}--active`
		else return cls
	}

	const labelSelected = options.find(_ => _.value === selectedVal)

	return (
		<div className='dropdown-search-wrap'>
			<div className='dropdown-search-container'>
				<div className='dropdown-search-label' ref={inputRef} onClick={handleClickInside}>
					<Button buttonSize={"btn--medium"} isLightButton={true}>
						{labelSelected ? <span>{labelSelected.label}</span> : <span>Select Filter</span>}
						<IconContext.Provider value={{className: "btn-icon"}}>
							<HiChevronDown />
						</IconContext.Provider>
					</Button>
				</div>
				{isOpen && (
					<div className='dropdown-search-window'>
						<div
							className='dropdown-collapse'
							ref={collapseRef}
							onClick={() => setIsCollapsed(!isCollapsed)}
							id={"collapseBtn"}
						>
							<div className='dropdown-collapse-selected'>
								{labelSelected ? <span>{labelSelected.label}</span> : <span>&nbsp;</span>}
							</div>
							<div className='dropdown-collapse-count'>
								<div className='dropdown-collapse-text'>({options.length} total)</div>
								<IconContext.Provider value={{className: "btn-icon collapse-btn"}}>
									{isCollapsed ? <HiChevronDown /> : <HiChevronUp />}
								</IconContext.Provider>
							</div>
						</div>
						{!isCollapsed && (
							<div className='dropdown-search-input'>
								<IconContext.Provider value={{className: "btn-icon"}}>
									<FiSearch />
								</IconContext.Provider>
								<input
									type='text'
									value={getDisplayValue()}
									name='searchTerm'
									placeholder='Search'
									onChange={e => {
										setQuery(e.target.value)
									}}
								/>
							</div>
						)}
						{!isCollapsed && (
							<div className='dropdown-list-scroll'>
								{filter(options).map((option, index) => {
									return (
										<div
											onClick={() => selectOption(option)}
											className={selectedClass("dropdown-search-row", option.value)}
											key={`${id}-${index}`}
										>
											<span className='dropdown-search-row-label'>{option[label]}</span>
											{option.value === selectedVal && (
												<IconContext.Provider value={{className: "btn-icon"}}>
													<FaCheck />
												</IconContext.Provider>
											)}
										</div>
									)
								})}
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	)
}

export default DropdownSearch
